import React from "react";
import { useTranslation } from "react-i18next";
import {
  EXERCISE_TYPE_ARRAY,
  MUSCLE_GROUP_SELECT_ARRAY,
  EXERCISE_TYPE,
  PRIMARY_MUSCLE_GROUP,
} from "../../constants";
import Select from "./select";
import { getMuscleGroupLabel, toI18nKey } from "../../utils/muscle-group-label";

function SelectExerciseTypeMuscleGroups({
  value,
  handleChange,
  type,
  form,
  overlay = false,
}) {
  const { t } = useTranslation("common");
  const name =
    type === EXERCISE_TYPE
      ? "exerciseTypeField"
      : type === PRIMARY_MUSCLE_GROUP
        ? "primaryMuscleGroup"
        : "secondaryMuscleGroup";
  const ns = type === EXERCISE_TYPE ? "exerciseType" : "muscleGroup";
  return (
    <Select
      name={name}
      value={value}
      form={form}
      overlay={overlay}
      onChange={(newVal) => handleChange({ target: { name, value: newVal } })}
      options={(type === EXERCISE_TYPE
        ? EXERCISE_TYPE_ARRAY
        : MUSCLE_GROUP_SELECT_ARRAY
      ).map((elem) => ({
        value: elem,
        // Muscle groups go through the shared helper so "Legs" is shown expanded
        // ("Legs (Quadriceps + Hamstrings)") consistently across the app; the
        // stored value stays "Legs". Exercise types keep their own translation.
        text:
          type === EXERCISE_TYPE
            ? t(`common:${ns}.${toI18nKey(elem)}`)
            : getMuscleGroupLabel(elem, t),
      }))}
    />
  );
}

export default SelectExerciseTypeMuscleGroups;
